import { extend } from 'vee-validate';
import { required, min_value, max_value, required_if } from 'vee-validate/dist/rules';

extend('required', required);
extend('required_if', required_if);
extend('min_value', min_value);
extend('max_value', max_value);
extend('url', (value) => {
    const stringValue = value.toString();
    if (['localhost', '127.0.0.1', 'customily'].includes(stringValue.toLowerCase())) return true;
    const regex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/i;
    return regex.test(stringValue) || 'Enter a valid URL';
});
extend('shopify-url', (value) => {
    return /^[\da-z-]+\.myshopify\.com$/i.test(value.toString()) || 'Enter a valid URL, e.g. YourStore.myshopify.com';
});
extend('shoplazza-url', (value) => {
    return /^[\da-z-]+\.myshoplaza\.com$/i.test(value.toString()) || 'Enter a valid URL, e.g. YourStore.myshoplaza.com';
});
extend('alpha_num', {
    validate: (value: string) => {
        return /^[\dA-Za-z]+$/.test(value);
    },
    message: 'Only letters and numbers are allowed'
});
